export default __webpack_public_path__ + "maps-guides-view-annotation-simple-960-d678315cf7b1b0f6979a7d59dcb24fe1.webp";